module.exports = __webpack_public_path__ + "next.png?d5289810cd1007fa8930cbc6e89a3cad";


//////////////////
// WEBPACK FOOTER
// ./dist/next.png
// module id = 12
// module chunks = 0